import { MediaModel } from "@src/utils/components/dropzone";
import { useEffect } from "react";
import type { Form } from "./Form";
import type { ModalOrderProps } from "./ModalOrder";

export const useFillForm = (
  args: Pick<ModalOrderProps, "order" | "prefillFields">,
  form: Form,

  /** Fill form on open */
  open: boolean,
) => {
  useEffect(() => {
    if (open) {
      if (args.order) {
        form.purchase_order_no.onChange(args.order.purchase_order_no ?? "");
        form.date_of_order.onChange(
          args.order.date_of_order
            ? new Date(args.order.date_of_order)
            : undefined,
        );
        form.brand_id.onChange(args.order.brand.id);

        if (args.order.projects) {
          form.project_ids.onChange(
            args.order.projects.flatMap((i) => (i ? [i.id] : [])),
          );
        }

        if (args.order.files?.length) {
          const files = args.order.files.flatMap((i) => {
            if (!i) return [];

            if (i instanceof MediaModel) {
              return [i];
            } else {
              return [new MediaModel(i)];
            }
          });

          if (files.length) {
            form.files.onChange(files);
          }
        }
      } else if (args.prefillFields?.brandId) {
        form.brand_id.onChange(args.prefillFields.brandId);

        if (args.prefillFields.projectIds?.length) {
          form.project_ids.onChange(args.prefillFields.projectIds);
        }
      }
    }
  }, [open]);
};
